import { IAppState } from '../../core/redux/IAppState';
import { apiRemoveUser } from '../../core/redux/api/endpoints';
import { hasTrippedBreaker, updateBreaker } from '../../core/redux/api/circuitBreaker/module';
import { ApiReducer, makeApiAction, makeApiReducer, RsaaTypes } from '../../core/redux/api/reduxStandardApiAction';
import { ACTION_TYPE } from '../../core/redux/actionType';
import { addError, addLoading, getLoading, removeLoadingAndError } from '../../core/redux/api/module';
import { assoc } from '../../language/module';


export const KEY_ACTION = ACTION_TYPE.REMOVE_USER_REQUEST;
export const ACTIONS    = [
  ACTION_TYPE.REMOVE_USER_REQUEST,
  ACTION_TYPE.REMOVE_USER_RESPONSE,
  ACTION_TYPE.REMOVE_USER_ERROR,
];


/**
 * Creates an action to dispatch that deletes a user
 */
export const deleteUserAction = (userId: string) => makeApiAction(
  {
    method:   'DELETE',
    headers:  (state: IAppState) => ({
      'Authorization': `Bearer ${state.auth.bearerToken}`,
    }),
    endpoint: (state: IAppState) => apiRemoveUser(state.userState.userId, state.selectedResort.resortId, userId),
    types:    ACTIONS.map(action => ({ type: action, meta: { userId } })) as RsaaTypes,
    bailout:  (state: IAppState) => hasTrippedBreaker(state, KEY_ACTION) || !!getLoading(state, userId, KEY_ACTION),
  },
);


const reducer: ApiReducer<any> = (state, action, error, isLoading, payload) => {
  const userId = action.meta.userId as string;

  if (isLoading) {
    return addLoading(state, userId, KEY_ACTION);
  }

  const withBreaker = updateBreaker(state, KEY_ACTION, !!error);

  if (error) {
    return addError(withBreaker, userId, KEY_ACTION, error);
  }

  const noLoadingOrError = removeLoadingAndError(withBreaker, userId, KEY_ACTION);

  return assoc(
    'users',
    (noLoadingOrError.users || []).filter(user => user.userId !== userId),
    noLoadingOrError,
  );
};


export const deleteUserReducer = makeApiReducer<any>(ACTIONS, KEY_ACTION, reducer);
